export type WireFlags = string | number | null | undefined;

export type PushNotificationConfiguration = {
  incidentNotificationType?: WireFlags;
  callNotificationType?: WireFlags;
};

export const INCIDENT_NOTIFICATION_TYPE = {
  None: 0,
  NewIncident: 1,
  IncidentPositionChanged: 1 << 1,
  IncidentPositionReplaced: 1 << 2,
  IncidentDataChanged: 1 << 3,
  IncidentClosed: 1 << 4,
  IncidentCollaborationRequested: 1 << 5,
  IncidentCollaborationConfirmed: 1 << 6,
  IncidentCollaborationRejected: 1 << 7,
  IncidentCollaboration: (1 << 5) | (1 << 6) | (1 << 7),
  All: 0xff,
} as const;

export const CALL_NOTIFICATION_TYPE = {
  None: 0,
  NewCall: 1,
  All: 1,
} as const;

export function toNumericFlags(value: WireFlags, names: Record<string, number>): number {
  if (typeof value === 'number') {
    return value;
  }
  if (typeof value !== 'string') {
    return 0;
  }

  return value
    .split(',')
    .reduce((flags, name) => flags | (names[name.trim()] ?? 0), 0);
}

export function incidentNotificationFlags(configuration: PushNotificationConfiguration): number {
  return toNumericFlags(configuration.incidentNotificationType, INCIDENT_NOTIFICATION_TYPE);
}

export function callNotificationFlags(configuration: PushNotificationConfiguration): number {
  return toNumericFlags(configuration.callNotificationType, CALL_NOTIFICATION_TYPE);
}

export function hasEnabledPushNotifications(
  configuration: PushNotificationConfiguration | null | undefined,
): configuration is PushNotificationConfiguration {
  if (configuration == null) {
    return false;
  }

  return incidentNotificationFlags(configuration) !== 0 || callNotificationFlags(configuration) !== 0;
}
